import { useState } from "react";
import { toast } from "sonner";
import { api, errorMessage, fmtDateTime, fmtKm } from "@/lib/api";
import { Field, Input } from "@/components/common/Field";
import { useRef } from "react";
import { Camera } from "lucide-react";
import { FileField, uploadVehiclePhoto } from "@/lib/uploads";
import { photoUrl } from "@/components/photos/Photos";

export function OdometerTab({ vehicle, reload }) {
  const [km, setKm] = useState("");
  const [note, setNote] = useState("");
  const [err, setErr] = useState(null);
  const fileRef = useRef();
  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    if (!km) return setErr("Enter the current reading in km");
    try {
      const file = fileRef.current?.files?.[0];
      const photo_id = file ? (await uploadVehiclePhoto(file, { vehicle_id: vehicle.id, note: `Odometer ${km} km` })).id : null;
      await api.post(`/vehicles/${vehicle.id}/odometer`, { reading_km: Number(km), note: note || null, photo_id });
      if (fileRef.current) fileRef.current.value = "";
      toast.success("Odometer recorded"); setKm(""); setNote(""); reload();
    } catch (e2) { setErr(errorMessage(e2)); }
  };
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
      <form onSubmit={submit} className="fv-card space-y-3 p-4" data-testid="odometer-form" noValidate>
        <p className="fv-caption">Current</p>
        <p className="text-2xl font-bold tracking-tight" data-testid="current-odometer">{fmtKm(vehicle.current_odometer_km)}</p>
        <Field label="New reading (km)" required error={err}><Input data-testid="odometer-input" type="number" inputMode="numeric" value={km} onChange={(e) => setKm(e.target.value)} error={!!err} /></Field>
        <Field label="Note"><Input data-testid="odometer-note-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Optional" /></Field>
        <FileField label="Photo of odometer (optional)" accept="image/*" inputRef={fileRef} testId="odometer-photo-input" />
        <button type="submit" data-testid="odometer-submit-btn" className="h-10 w-full rounded-full bg-primary text-sm font-semibold text-primary-foreground hover:bg-[#0071e3]">Record reading</button>
      </form>
      <div className="fv-card divide-y p-1 lg:col-span-2" data-testid="odometer-history">
        {vehicle.odometer_readings.length === 0 ? <p className="p-4 text-sm text-muted-foreground">No readings yet.</p> : vehicle.odometer_readings.map((r) => (
          <div key={r.id} className="fv-dense-row cursor-default">
            <span className="w-28 font-semibold">{fmtKm(r.reading_km)}</span>
            <span className="min-w-0 flex-1 truncate text-muted-foreground">{r.note || "—"}</span>
            {r.photo_id && <a href={photoUrl(r.photo_id)} target="_blank" rel="noreferrer" data-testid={`odometer-photo-${r.id}`} className="text-primary" aria-label="View photo"><Camera className="h-4 w-4" /></a>}
            <span className="text-[11px] text-muted-foreground">{fmtDateTime(r.recorded_at)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
